import { render, staticRenderFns } from "./AdminNew.vue?vue&type=template&id=0970c5a8&scoped=true"
import script from "./AdminNew.vue?vue&type=script&lang=js"
export * from "./AdminNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0970c5a8",
  null
  
)

export default component.exports